export function cloudflareImageApi() {
  const uploadImageByUploadUrl = async (uploadUrl: string, file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return fetch(uploadUrl, {
      method: 'POST',
      body: formData,
    })
  }

  const uploadVideoByUploadUrl = async (uploadUrl: string, file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return fetch(uploadUrl, {
      method: 'POST',
      body: formData,
    })
  }

  return {
    uploadImageByUploadUrl,
    uploadVideoByUploadUrl,
  }
}
